module.exports = __webpack_public_path__ + "static/media/backingMat.fd9add37.png";